"use strict";

exports.__esModule = true;
exports.ItemSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
var _icons = require("@blueprintjs/icons");
var _Selector = require("../../../Core/Selector");
var _Translator = require("../../../Core/Translator");
var _helpers = require("./helpers");
var _styledComponents = require("styled-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ItemSelector = exports.ItemSelector = function ItemSelector(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var availableItems = (0, _helpers.getAvailableItems)(props);
  var series = props.series,
    index = props.index,
    getKey = props.getKey,
    selectedItems = props.selectedItems,
    onChange = props.onChange,
    renderItemText = props.renderItemText,
    itemPredicate = props.itemPredicate,
    renderItemLabel = props.renderItemLabel,
    _props$defaultColor = props.defaultColor,
    defaultColor = _props$defaultColor === void 0 ? theme.DefaultChartColor || "#1678c2" : _props$defaultColor,
    position = props.position,
    width = props.width;
  return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    "data-testid": "multi-field-selector-fields-input-test-id",
    placeholder: translate("MetricSelector.placeholder.single", "Select Item"),
    getKey: getKey,
    width: width || 275,
    renderItemText: renderItemText || function (input) {
      return input.key;
    },
    itemPredicate: itemPredicate,
    renderItemLabel: renderItemLabel,
    onSelect: function onSelect(selected) {
      if (getKey(series) === getKey(selected[0])) {
        return;
      }
      var updated = selectedItems.slice();
      updated[index] = Object.assign({}, updated[index], selected[0], {
        color: updated[index].color || defaultColor
      });
      onChange(updated);
    },
    selected: [getKey(series)],
    items: [series].concat(availableItems),
    position: position
  }, /*#__PURE__*/_react["default"].createElement(_styles.FieldSelectorButton, {
    "data-testid": "multi-field-selector-selected-field-test-id",
    rightIcon: _icons.IconNames.DOUBLE_CARET_VERTICAL,
    style: {
      width: "140px"
    },
    text: renderItemText(series) || "Select a Value"
  }));
};